'use strict'

import { useState, useEffect } from 'react'

function getBreakPoint(windowWidth) {
  // this function uses following values for breakpoints:
  // xs: 0,
  // sm: 640px,
  // md: 960px,
  // lg: 1280px,
  // xl: 1600px,
  // xxl: 1920px

  if (windowWidth) {
    let breakpoint = 'xxl'

    switch (true) {
      case windowWidth < 640:
        breakpoint = 'xs'
        break
      case windowWidth < 960:
        breakpoint = 'sm'
        break
      case windowWidth < 1280:
        breakpoint = 'md'
        break
      case windowWidth < 1600:
        breakpoint = 'lg'
        break
      case windowWidth < 1920:
        breakpoint = 'xl'
        break
      default:
        breakpoint = 'xxl'
    }
    return breakpoint
  }

  return undefined
}

function useBreakpoint() {
  const isClient = typeof window !== 'undefined'
  const [windowSize, setWindowSize] = useState(
    isClient ? getBreakPoint(window.innerWidth) : undefined
  )

  useEffect(() => {
    setWindowSize(getBreakPoint(window.innerWidth))

    function setSize() {
      setWindowSize(getBreakPoint(window.innerWidth))
    }

    window.addEventListener('resize', setSize)

    return () => window.removeEventListener('resize', setSize)
  }, [])

  return windowSize
}

export { getBreakPoint }

export default useBreakpoint
